import React from 'react';
import './HomeSlider.css';
import { Box, Skeleton } from '@mui/material';
import { PUBLIC_CMS_URL, IMAGE_DIR_PATH } from '../../../APIs/endpoint';

const HomeDataDisplay = ({ homeSliderData, isLoader }) => (
  <Box
    className="data-container"
    sx={{ maxHeight: { xs: 'initial', sm: 'initial', md: 470, lg: 639 } }}>
    {isLoader ? (
      <Skeleton
        variant="rectangular"
        sx={{
          width: { xs: '100%', sm: '100%', md: 1000, lg: 1399, xl: 1900 },
          height: { xs: 252, sm: 320, md: 470, lg: 639 }
        }}
      />
    ) : (
      homeSliderData?.map((item, i) => (
        <Box key={i} className="img_section">
          <img
            loading={i === 0 ? 'eager' : 'lazy'}
            src={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.HOME_BANNER_SLIDER_PATH1}${item.banner_image}`}
            alt="Slider_img"
            width={1500}
            height={570}
          />
          <div className="banner-overlay">
            <div className="set-style">
              <h2 className="banner-title">{item.banner_title}</h2>
              <p className="banner-description">{item.banner_description}</p>
            </div>
          </div>
        </Box>
      ))
    )}
  </Box>
);

export default React.memo(HomeDataDisplay);
